import styled from 'styled-components';

import { Spend, SWReactIcons } from '@similarweb/icons';
import { $dmSansFontFamily, colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledCreditsBlock = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${colorsPalettes.carbon[50]};
  border-radius: 8px;
  padding: 16px;
  row-gap: 16px;
  margin: 0 0 24px;
`;

export const StyledCreditItem = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
`;

export const StyledCreditTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  ${setFontVariant('report', colorsPalettes.carbon[500])};
  line-height: 20px;
`;

export const StyledCreditSubTitle = styled.div`
  ${setFontVariant('sectionTitle', colorsPalettes.carbon[250])};
`;

export const StyledCreditCountContainer = styled.div`
  display: flex;
  gap: 4px;
  margin-left: auto;
  align-items: center;
`;

export const StyledCreditCount = styled.span`
  display: flex;
  align-self: center;
  align-items: center;
  margin-left: auto;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  font-family: ${$dmSansFontFamily};
`;

export const StyledSpendIcon = styled(Spend)`
  margin-right: 8px;
`;

export const StyledContactsIcon = styled(SWReactIcons)`
  margin-right: 8px;

  svg circle,
  svg path {
    stroke: ${colorsPalettes.carbon[500]};
  }
`;

export const StyledInsightsIcon = styled(SWReactIcons)`
  margin-right: 8px;
`;

export const StyledOverviewIcon = styled(SWReactIcons)`
  margin-left: 4px;
  width: 19px;
`;
